{
  "manager": {
    "integrationsCard": {
      "disconnect": "Disconnect",
      "disconnectTitle": "Disconnect {label}",
      "disconnectBody": "Disconnecting removes the active connection and immediately disables its features."
    }
  }
}
